import React from "react";
import CompanySection from "../components/About/CompanySection";
import MissionSection from "../components/About/MissionSection";
import ValuesSection from "../components/About/ValuesSection";
import RedSection from "../components/About/RedSection";

const About = () => {
  return (
    <>
      <MissionSection />
      <ValuesSection />
      <RedSection />
    </>
  );
};

export default About;
